(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["address-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('address-input')) {
    customElements.define('address-input', class AddressInput extends HTMLElement {
      constructor() {
        super();
        this.onFieldInput = this.onFieldInput.bind(this);
      }

      connectedCallback() {
        this.visibleFields = Array.from(
          this.querySelectorAll('input:not([type="hidden"])')
        );
        this.hiddenField = this.querySelector('input[type="hidden"]');

        if (!this.hiddenField || !this.visibleFields.length) return;

        this.visibleFields.forEach((field) => {
          field.addEventListener('input', this.onFieldInput);
          field.addEventListener('change', this.onFieldInput);
        });

        this.updateHiddenField();
      }

      disconnectedCallback() {
        if (!this.visibleFields) return;

        this.visibleFields.forEach((field) => {
          field.removeEventListener('input', this.onFieldInput);
          field.removeEventListener('change', this.onFieldInput);
        });
      }

      onFieldInput() {
        this.updateHiddenField();
      }

      updateHiddenField() {
        if (!this.hiddenField) return;

        const address1 = this.getFieldValue('-address-1');
        const address2 = this.getFieldValue('-address-2');
        const city = this.getFieldValue('-city');
        const state = this.getFieldValue('-state');
        const zip = this.getFieldValue('-zip');

        const street = [address1, address2].filter(Boolean).join(' ');
        const cityStateZip = [city, state, zip].filter(Boolean).join(' ');
        const compiledAddress = [street, cityStateZip].filter(Boolean).join(', ');

        this.hiddenField.value = compiledAddress;
      }

      getFieldValue(idSuffix) {
        const field = this.querySelector(`input[id$="${idSuffix}"]`);
        return field ? field.value.trim() : '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blog-tags')) {
    customElements.define('blog-tags',
      class BlogTags extends HTMLElement {
        constructor() {
          super();

          this.scrollEl = this.querySelector('[data-scroll-el]');
          this.wrapper = this.closest('section');
          this.containerEl = this.querySelector('[data-container-el]');
          this.endControl = this.querySelector('[data-control-end]');
          this.startControl = this.querySelector('[data-control-start]');
          this.activeTag = null;
        }

        connectedCallback() {
          this.getScrollPosition();
          this.setActiveTag();
          this.scrollTagIntoView();
          this.showNav();
          this.scrollEl.addEventListener('scroll', this.handleScroll.bind(this));
          this.endControl.addEventListener('click', this.scrollToEnd.bind(this));
          this.startControl.addEventListener('click', this.scrollToStart.bind(this));
        }

        handleScroll() {
          const position = this.getScrollPosition();
          this.setAttribute('data-position', position);
        }

        getScrollPosition() {
          this.scrollElWidth = this.scrollEl.scrollWidth;
          this.scrollElVisibleWidth = this.scrollEl.clientWidth;
          this.scrollElScrollPosition = this.scrollEl.scrollLeft;
          const edgeThreshold = 40;

          if (this.scrollElScrollPosition <= edgeThreshold) {
            return 'start'
          } else if (this.scrollElWidth - this.scrollElScrollPosition - this.scrollElVisibleWidth <= edgeThreshold) {
            return 'end';
          } else {
            return 'middle'
          }
        }

        scrollToEnd() {
          const scrollTarget = this.scrollElWidth - this.scrollElVisibleWidth;
          this.scrollEl.scrollTo({
            left: scrollTarget,
            behavior: 'smooth'
          });
        }

        scrollToStart() {
          this.scrollEl.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        }

        showNav() {
          if (this.scrollEl.scrollWidth > this.scrollEl.clientWidth) {
            this.setAttribute('data-show-nav', 'true');
          }
        }

        setActiveTag() {
          const currentUrl = window.location.href;
          const taggedIndex = currentUrl.indexOf('/tagged/');
          const queryIndex = currentUrl.indexOf('?');
          let slug;
          if (taggedIndex !== -1 && queryIndex !== -1 && taggedIndex < queryIndex) {
            slug = currentUrl.substring(taggedIndex + '/tagged/'.length, queryIndex);
          } else if (taggedIndex !== -1) {
            slug = currentUrl.substring(taggedIndex + '/tagged/'.length);
          } else {
            slug = null;
          }

          if (!slug) {
            this.activeTag = this.querySelector('[data-tag]:not([data-slug])');
            this.activeTag.classList.add('active');
          } else {
            this.activeTag = this.querySelector(`[data-tag][data-slug="${slug}"]`);
            this.querySelector(`[data-tag][data-slug="${slug}"]`).classList.add('active');
            this.scrollPostsIntoView();
          }
        }

        scrollTagIntoView() {
          if (!this.activeTag || !this.activeTag.hasAttribute('data-slug')) return;

          this.activeTag.scrollIntoView({
            behavior: "instant",
            block: "center",
            inline: "center",
          });
        }

        scrollPostsIntoView() {
          window.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
              this.wrapper.scrollIntoView({
                behavior: "instant",
                block: "start",
              });
            });
          });
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-team-member"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('team-card')) {
    customElements.define(
      'team-card',
      class TeamCard extends HTMLElement {
        constructor() {
          super();
          this.triggers = this.querySelectorAll('button');
        }

        connectedCallback() {
          this.triggers.forEach((el) => {
            el.addEventListener('click', this.flipCard.bind(this));
          });
        }

        flipCard() {
          this.setAttribute('data-flipped', !(this.dataset.flipped === 'true'));
        }

        disconnectedCallback() {
          this.triggers.forEach((el) => {
            el.removeEventListener('click', this.flipCard);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["file-upload"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('file-upload')) {
  customElements.define(
    'file-upload',
    class FileUpload extends HTMLElement {
      constructor() {
        super();
        this.fileData = null;
        this.maxSize = parseInt(this.dataset.maxSize) || 10 * 1024 * 1024; // 10MB default
      }

      connectedCallback() {
        this.uploadZone = this.querySelector('[data-upload-zone]');
        this.uploadContent = this.querySelector('[data-upload-content]');
        this.filePreview = this.querySelector('[data-file-preview]');
        this.fileInput = this.querySelector('[data-file-input]');
        this.fileName = this.querySelector('[data-file-name]');
        this.fileRemove = this.querySelector('[data-file-remove]');

        this.bindEvents();
      }

      bindEvents() {
        this.fileInput?.addEventListener('change', (e) => this.handleFileSelect(e));
        this.uploadZone?.addEventListener('dragover', (e) => this.handleDragOver(e));
        this.uploadZone?.addEventListener('dragleave', (e) => this.handleDragLeave(e));
        this.uploadZone?.addEventListener('drop', (e) => this.handleDrop(e));
        this.fileRemove?.addEventListener('click', () => this.removeFile());
      }

      handleDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
        this.uploadZone.classList.add('file-upload__zone--dragover');
      }

      handleDragLeave(e) {
        e.preventDefault();
        e.stopPropagation();
        this.uploadZone.classList.remove('file-upload__zone--dragover');
      }

      handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.uploadZone.classList.remove('file-upload__zone--dragover');

        const files = e.dataTransfer.files;
        if (files.length > 0) {
          this.processFile(files[0]);
        }
      }

      handleFileSelect(e) {
        const files = e.target.files;
        if (files.length > 0) {
          this.processFile(files[0]);
        }
      }

      processFile(file) {
        const validTypes = [
          'image/jpeg',
          'image/png',
          'image/heic',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ];

        if (!validTypes.includes(file.type) && !file.name.match(/\.(jpg|jpeg|png|heic|pdf|doc|docx)$/i)) {
          alert('Please upload a valid file type (JPG, PNG, HEIC, PDF, DOC, or DOCX)');
          return;
        }

        if (file.size > this.maxSize) {
          alert('File size must be less than 10MB');
          return;
        }

        // Store the raw file for FormData submission
        this.fileData = {
          name: file.name,
          type: file.type,
          size: file.size,
          file: file, // Store the raw File object for upload
        };

        this.updatePreview();
        this.dispatchChangeEvent();
      }

      updatePreview() {
        if (this.fileData) {
          this.fileName.textContent = this.fileData.name;
          this.uploadContent.setAttribute('data-disabled', 'true');
          this.filePreview.hidden = false;
          this.uploadZone.classList.add('file-upload__zone--has-file');
        } else {
          this.uploadContent.removeAttribute('data-disabled');
          this.filePreview.hidden = true;
          this.uploadZone.classList.remove('file-upload__zone--has-file');
        }
      }

      removeFile() {
        this.fileData = null;
        this.fileInput.value = '';
        this.updatePreview();
        this.dispatchChangeEvent();
      }

      dispatchChangeEvent() {
        this.dispatchEvent(
          new CustomEvent('file:change', {
            bubbles: true,
            detail: {
              file: this.fileData
                ? {
                  name: this.fileData.name,
                  type: this.fileData.type,
                  size: this.fileData.size,
                  file: this.fileData.file,
                }
                : null,
            },
          })
        );
      }

      getData() {
        return this.fileData;
      }

      getFile() {
        return this.fileData?.file || null;
      }

      reset() {
        this.removeFile();
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("price-subtotal")) {
    customElements.define(
      "price-subtotal",
      class PriceSubtotal extends HTMLElement {
        constructor() {
          super();
          this.sectionId = this.dataset.sectionId;
          this.originalPrice = this.dataset.originalPrice;
          this.productId = this.dataset.productId;
          this.productForm = document.querySelector(`#product-form-${this.sectionId} form`);
          this.quantityControl = document.getElementById(`quantity-input-${this.sectionId}`);
          this.quantityInput = document.getElementById(`Quantity-${this.sectionId}`);
          this.totalEl = this.querySelector('[data-subtotal-total]');
          this.priceEl = this.querySelector('[data-subtotal-price]');
          this.observer = null;
        }

        connectedCallback() {
          if (!this.sectionId) return;
          // window.addEventListener("cart_changed", this.resetPrice.bind(this));
          if (this.quantityControl) {
            this.quantityControl.addEventListener("change", this.onQuantityChange.bind(this));
            this.setupPriceObserver();
          }
        }

        _parseMoney(str) {
          const num = parseFloat(str.replace(/[^0-9.]/g, ''));
          return Math.round(num * 100);
        }

        _formatMoney(cents, currency = 'USD', locale = 'en-US') {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(cents / 100);
        }

        resetPrice(e) {
          if (e.detail.changedCartItems.length === 0) return;
          this.totalEl.textContent = this._formatMoney(parseInt(this.originalPrice));
        }

        onQuantityChange(e) {
          const price = this.priceEl.textContent;
          const quantityVal = parseInt(e.target.value);
          this.totalEl.textContent = this._formatMoney(this._parseMoney(price) * quantityVal);
        }

        setupPriceObserver() {
          if (this.observer) {
            this.observer.disconnect();
          }

          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'characterData' || mutation.type === 'childList') {
                const price = this.priceEl.textContent;
                const quantityVal = parseInt(this.quantityInput.value);
                this.totalEl.textContent = this._formatMoney(this._parseMoney(price) * quantityVal);
              }
            });
          });

          this.observer.observe(this.priceEl, {
            characterData: true,
            childList: true,
            subtree: true
          });
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-add-ons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('add-on-product')) {
    customElements.define(
      'add-on-product',
      class AddOnProduct extends HTMLElement {
        constructor() {
          super();
          this.trigger = this.querySelector('[data-trigger]');
          this.quantityInput = this.querySelector('input[name$="[quantity]"]');
          this.variantSelect = this.querySelector('[data-variant-select]');
          this.removeButton = this.querySelector('[data-remove]');
          this.priceEl = this.querySelector('[data-price-el]');
          this.currentVariantId = parseInt(this.dataset.defaultVariantId);
        }

        connectedCallback() {
          this.getDefaultVariant();
          if (this.trigger) {
            this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
          }
          if (this.variantSelect) {
            this.variantSelect.addEventListener('change', this.onVariantChange.bind(this));
          }
          if (this.removeButton) {
            this.removeButton.addEventListener('click', this.onRemoveClick.bind(this));
          }
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.onParentVariantChange.bind(this)
          );
        }

        getDefaultVariant() {
          this.currentVariant = this.getVariantData().find((variant) => {
            return variant.id === this.currentVariantId;
          });
        }

        onTriggerClick(event) {
          event.preventDefault();
          this.addAddon();
        }

        onRemoveClick(event) {
          event.preventDefault();
          this.removeAddon();
        }

        onQuantityChange(event) {
          this.updatePrice();
        }

        onParentVariantChange(event) {
          const units = event.data.units;
          if (!units) return;
          this.updateUnits(units);
        }

        updateOptions() {
          this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
        }

        updateUnits(units) {
          if (!units || !this.quantityInput) return;
          this.quantityInput.value = units;
          this.updatePrice();
        }

        onVariantChange(event) {
          if (event.target.value === '') {
            this.removeAddon(true);
          } else {
            this.trigger.disabled = false;
            this.updateOptions();
            this.updateMasterId();
            this.updateInput();
            // this.updatePrice();
            this.addAddon();
          }
        }

        removeAddon(disableTrigger = false) {
          this.dataset.added = 'false';
          this.querySelectorAll('input').forEach((input) => {
            input.disabled = true;
          });
          this.hideConditionalFields();
          if (disableTrigger) {
            this.trigger.disabled = true;
          }
          if (this.variantSelect) {
            this.variantSelect.value = '';
            this.trigger.disabled = true;
          }
          this.updatePrice(0);
        }

        addAddon() {
          this.dataset.added = 'true';
          this.querySelectorAll('input[type="hidden"]').forEach((input) => {
            input.disabled = false;
          });
          this.showConditionalFields();
          this.updatePrice();
        }

        updateMasterId() {
          this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
              .map((option, index) => {
                return this.options[index] === option;
              })
              .includes(false);
          });
        }

        updateInput() {
          this.querySelector('input[name$="[id]"]').value = this.currentVariant.id;
        }

        updatePrice(setPrice) {
          if (setPrice) {
            this.dataset.price = setPrice;
          } else {
            let priceCents;
            if (this.quantityInput) {
              const quantity = parseInt(this.quantityInput.value);
              priceCents = this.currentVariant.price * quantity;
              this.priceEl.textContent = `+${Shopify.formatMoney(priceCents, '${{amount}}')}`;
              if (priceCents === 0) {
                this.priceEl.textContent = 'Included';
              }
            } else {
              priceCents = this.currentVariant.price;
              this.priceEl.textContent = `+${Shopify.formatMoney(priceCents, '${{amount}}')}`;
              if (priceCents === 0) {
                this.priceEl.textContent = 'Included';
              }
            }

            this.dataset.price = priceCents;
          }

          // Dispatch event to notify total-price element
          publish(PUB_SUB_EVENTS.addonPriceChange, {
            data: {
              sectionId: this.dataset.sectionId,
              addOn: this,
            },
          });
        }

        showConditionalFields() {
          const fields = this.querySelectorAll('[data-fields] [data-variant-id]');
          fields.forEach((field) => {
            if (parseInt(field.dataset.variantId) === parseInt(this.currentVariant.id)) {
              field.disabled = false;
            } else {
              field.disabled = true;
            }
          });
        }

        hideConditionalFields() {
          const fields = this.querySelectorAll('[data-fields] [data-variant-id]');
          fields.forEach((field) => {
            field.disabled = true;
          });
        }

        getVariantData() {
          this.variantData =
            this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
          return this.variantData;
        }

        disconnectedCallback() {
          if (this.variantChangeUnsubscriber) {
            this.variantChangeUnsubscriber();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["radio-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('radio-input')) {
    customElements.define('radio-input', class RadioInput extends HTMLElement {
      constructor() {
        super();
        this.labelId = this.dataset.labelId;
        this.labelEl = document.querySelector(`[data-label-id="${this.labelId}"]`);
      }

      connectedCallback() {
        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange(event) {
        const checkedInput = this.querySelector('input:checked');
        if (!this.labelEl) return;
        this.labelEl.innerText = checkedInput.value;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
